import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const TableWrapper = styled.table`
  width: 100%;
  bordercollapse: "collapse";
`;

const TableHeader = styled.thead``;
const TableBody = styled.tbody``;

const TableRow = styled.tr<{ $hover?: boolean }>`
  cursor: ${({ $hover }) => ($hover ? "pointer" : "default")};
  &:hover {
    background-color: ${({ $hover }) =>
      $hover ? "rgba(0, 0, 0, 0.05)" : "transparent"};
  }
`;
const TableColumn = styled.td`
  padding: 10px;
  border: none;
  border-bottom: 1px solid #ccc;
`;

interface Props {
  columns: {
    title: string;
    key: string;
  }[];
  rows: {
    [key: string]: string | number | boolean | React.ReactNode;
  }[];
  onRowClick?: (row: {
    [key: string]: string | number | boolean | React.ReactNode;
  }) => void;
}

const Table: React.FC<Props> = ({ columns, rows, onRowClick }) => {
  return (
    <Wrapper>
      {rows.length > 0 ? (
        <TableWrapper>
          <TableHeader>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #ccc",
                    textAlign: "left",
                  }}
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </TableHeader>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                $hover={onRowClick !== undefined ? true : false}
                key={`row-${index}`}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((column) => (
                  <TableColumn key={column.key}>{row[column.key]}</TableColumn>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </TableWrapper>
      ) : (
        <p style={{ width: "100%", textAlign: "center" }}>
          {" "}
          Nu sunt date de afisat
        </p>
      )}
    </Wrapper>
  );
};

export default Table;
